import type { ReactNode } from "react"

/**
 * Grid katalog responsif: 1 kolom pada layar sangat sempit, 2 kolom pada ponsel normal, maksimal
 * 3 kolom pada viewport lebih lebar (plan PR5 §2). Kolom diatur di `styles.css` (`.sok-grid`) supaya
 * katalog tamu dan pratinjau owner memakai aturan yang sama persis.
 */
export const GridKatalog = ({ children }: { children: ReactNode }) => (
  <div className="sok-grid">{children}</div>
)
